import { Navigate, Outlet } from "react-router-dom";

import { useScope } from "@/hooks/useScope";

import { useSettingsEntity } from "./useSettingsEntity";

export function SettingsEntityGate() {
  const { entity, identifier, isLoading } = useSettingsEntity();
  const { entities } = useScope();

  if (!identifier) {
    return <Navigate to="/app/settings" replace />;
  }

  // Not one of the person's businesses only once they are read: a link
  // straight here was sent on to the profile while they still loaded.
  if (!entity && !isLoading) {
    const firstEntity = entities?.[0];
    if (firstEntity?.identifier) {
      return (
        <Navigate
          to={`/app/settings/entity/${firstEntity.identifier}`}
          replace
        />
      );
    }
    return <Navigate to="/app/settings/profile" replace />;
  }

  return <Outlet />;
}
